// extracted by mini-css-extract-plugin
module.exports =  {"content":"_0bc5e8de02--content--MUVqp","head":"_0bc5e8de02--head--J4KHl","item":"_0bc5e8de02--item--PYkqZ","child":"_0bc5e8de02--child--_YU4v"};